import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../../../context/SnackbarContext";
import { ssoIncomingItemQuery } from "../../supportFunctions/graphql/SSOIncomingQueries";
import * as Permissions from "../../supportFunctions/Permissions";
import MetadataForm, { Mode } from "./MetadataForm";
import { PageHeader } from "@velocity-ehs/component-library";
import { useTranslation } from "react-i18next";
import UsersService from "@velocity-ehs/user-utils-module";
import AuthService from "./services/AuthService";
import { useFlags } from "launchdarkly-react-client-sdk";
import VerticalTabs from "../../sharedComponents/VerticalTabs";
import { MetadataFormValues } from "./Metadata";
import { useForm } from "react-hook-form";

const EditMetadata: React.FC<{ editPermission: string[] }> = ({
  editPermission = [],
}) => {
  const { productChangeTracking } = useFlags();
  const { id } = useParams<{ id: string }>();
  const [metadata, setMetadata] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  const { showSnackbar } = useSnackbarActionContext();
  const { t } = useTranslation();
  const history = useHistory();
  const mode = Permissions.IsAllowed(editPermission, UsersService.permissions)
    ? Mode.Edit
    : Mode.View;

  const formMethods = useForm<MetadataFormValues>({
    mode: "onBlur",
  });

  const getMetadata = async () => {
    setIsLoading(true);
    AuthService.graphql()
      .post("", ssoIncomingItemQuery(id))
      .then((response: any) => {
        const responseData = response.data.data.SSOIncoming;
        const ssoIncoming = {
          name: responseData.customer.customerDomainName,
          entityId: responseData.entityId,
          ssoURL: responseData.ssoURL,
          ssoLogOutBinding: responseData.ssoLogOutBinding,
          ssoLogOutURL: responseData.ssoLogOutURL,
          customer: responseData.customer.name,
          customerid: responseData.customer.id,
          id: responseData.id,
          x509Cert: responseData.x509Cert,
          jitEnabled: responseData.jitEnabled,
        };
        setMetadata(ssoIncoming);
      })
      .catch((error: any) => {
        /* eslint-disable-next-line no-console */
        console.log(error);
        attemptShowErrorsInSnackbar(showSnackbar, error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getMetadata();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <PageHeader
        title={t("universal_Single_Sign_On")}
        navigationTree={[
          { text: `Accelerate ${t("universal_Home")}`, href: "/" },
          {
            text: t("universal_Single_Sign_On"),
            href: "/singleSignOn",
          },
          {
            text: t("action_edit"),
            href: "",
          },
        ]}
        primaryButton={{
          loading: formMethods.formState.isSubmitting,
          type: "submit",
          form: "singleSignOnForm",
          label: t("universal_Save"),
        }}
        secondaryButton={{
          type: "button",
          label: t("universal_Cancel"),
          className: "p-button-text",
          onClick: () => history.push("/singleSignOn"),
        }}
      />
      <VerticalTabs
        includeChangeTracking={productChangeTracking}
        targetIdentifierType="sso"
        tabs={[
          {
            title: t("universal_Single_Sign_On"),
            content: (
              <MetadataForm
                mode={mode}
                onSaveChanges={getMetadata}
                metaData={metadata}
                isLoading={isLoading}
                formMethods={formMethods}
              />
            ),
          },
        ]}
      />
    </>
  );
};

export default EditMetadata;
